import React from 'react'

export default function ButtonLoader() {
    return (
        <div className="smallSpinner mx-auto"></div>
    )
}
